import { Button, Flex, Form, Input } from "antd"
import { EmailTemplateTypes } from "../../common/constants"
import VSpace from "../common/VSpace"
import RichTextEditor from "../RichTextEditor/RichTextEditor"
import { EmailTemplate, emailTemplateTokens, hasRichTextSubject, requiredBodyPlaceholderError } from "./emailTemplateModel"

export type Props = {
  emailTemplate: EmailTemplate
  onCancel?: () => void
  onSubmit?: (emailTemplate: EmailTemplate) => void
}

const EmailTemplateForm = ({ emailTemplate, onCancel, onSubmit }: Props) => {
  const [form] = Form.useForm()

  const handleCancel = () => {
    form.resetFields()
    onCancel?.()
  }

  const tokens = emailTemplateTokens(emailTemplate.type)

  return <VSpace>
    <Form initialValues={emailTemplate} layout="vertical" form={form} onFinish={onSubmit}>
      <Form.Item name="guid" hidden={true}><Input type="hidden" /></Form.Item>
      <Form.Item name="type" hidden={true}><Input type="hidden" /></Form.Item>
      <Form.Item label="Name" name="name">
        <Input placeholder="Email Template Name" />
      </Form.Item>
      <Form.Item label="Email Subject" name="emailSubject">
        {hasRichTextSubject(emailTemplate.type)
          ? <RichTextEditor value="" tokens={tokens} singleLine/>
          : <Input placeholder="Email Subject" />
        }
      </Form.Item>
      <Form.Item
        label="Email Body"
        name="emailBody"
        rules={[
          {
            validator: (_, value: string) =>{
              const error = requiredBodyPlaceholderError(emailTemplate.type, value)
              return error === undefined ? Promise.resolve() : Promise.reject(new Error(error))
            }
          },
        ]}>
        <RichTextEditor value="" tokens={tokens} />
      </Form.Item>
      {emailTemplate.type === EmailTemplateTypes.Consultation &&
        <Form.Item label="Event Description" name="eventDescription">
          <Input.TextArea />
        </Form.Item>
      }
      <Flex justify="end" gap={8}>
        <Button onClick={handleCancel}>Cancel</Button>
        <Button htmlType="submit" type="primary">Save</Button>
      </Flex>
    </Form>
  </VSpace>
}

export default EmailTemplateForm
